<patron-modal
  [visible]="visible"
  (cancel)="close()"
  size="xl"
  [headerTemplate]="headerTemplate"
  [showFooter]="false"
  [closeButton]="false">
  <ng-template #headerTemplate>
    <div class="w-100">
      <div class="bg-primary pl-0 row justify-content-end">
        <div class="col-auto px-0">
          <patron-button
            customClass="z-index-1 text-white"
            variant="ghost"
            iconName="bi bi-window-stack"
            (click)="openInNewTab()"></patron-button>
        </div>

        <div class="col-auto pl-0">
          <patron-button
            variant="ghost"
            customClass="z-index-1 text-white"
            iconName="bi bi-x-lg"
            (click)="close()"></patron-button>
        </div>

        <ticket-show-header
          class="w-100"
          [entity]="entity"
          [isSaving]="saving"
          [popoverBaseZIndex]="10000"
          [popoverAppendTo]="null"
          [showSaveButton]="false"></ticket-show-header>
      </div>
    </div>
  </ng-template>

  <ticket-show-body
    [entity]="entity"
    [hasConfirmation]="true"
    (saved)="saved = $event"
    [loading]="loading"
    (saving)="saving = $event"
    [isSaving]="saving"
    [showSaveButton]="true"
    [taskId]="taskId"
    [showTabsBodies]="showTabsBodies"
    [user]="userLogged"></ticket-show-body>
</patron-modal>

<!-- <div class="modal-header bg-primary pl-0">
    <button title="Abrir em uma nova guia" class="btn btn-primary btn-open-tab" (click)="openInNewTab()">
      <i class="fa fa-window-restore"></i>
    </button> -->
<!-- <button title="Fechar" class="btn btn-primary btn-close" (click)="modal.hide()">
      <i class="fa fa-close"></i>
    </button> -->
<!-- <button title="Fechar" class="btn btn-primary btn-close" >
      <i class="fa fa-close"></i>
    </button>

    <ticket-show-header
      class="w-100"
      [entity]="entity"
      [isSaving]="saving"
      [showSaveButton]="false"
    ></ticket-show-header>
  </div> -->

<!-- <div #ticketModalBody class="modal-body ticket-modal-body p-0">
    <div class="ticket-show-body-container bg-primary pt-2">
      <ticket-show-body
        [entity]="entity"
        [hasConfirmation]="true"
        (saved)="saved = $event"
        [loading]="loading"
        (saving)="saving = $event"
        [isSaving]="saving"
        [showSaveButton]="true"
        [taskId]="taskId"
      ></ticket-show-body>
    </div>
  </div> -->

<!-- <div class="loading" *ngIf="saving || loading">
    <span>
      <i class="fa fa-5x fa-cog fa-spin"></i>
    </span>
  </div> -->
